import styled from '@emotion/styled';
import jQuery from 'jquery';
import React from 'react';
import { VirtuosoGrid } from 'react-virtuoso';

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`


let canvasSize = 150

function nextType(id) {
  let next = false;
  for (let i in window.types) {
    if (window.types.hasOwnProperty(i)) {
      if (next)
        return i;
      else if (i == id)
        next = true;
    }
  }
  for (let i in window.types)
    if (window.types.hasOwnProperty(i))
      return i;
}

function getImagePathForBrowser(path) {
  let extIndex = path.lastIndexOf('.');
  if (extIndex >= 0) {
    path = path.substring(0, extIndex) + '.jpg';
  }

  return path;
}

function reset_imageCanvas_position() {

	jQuery(`.imageWrapper[data-cadr="0"]:not(.ui-draggable-dragging) .imageCanvas img`).map(function () {
		let key = jQuery(this).parents(".imageWrapper").attr("id").replace('wrap_', '')
		if (window.images[key]["position_v"] == 0)
			jQuery(this).css("top", 0)

		if (window.images[key]["position_h"] == 0)
			jQuery(this).css("left", 0)
	})

	jQuery(`.imageWrapper[data-cadr="1"] .imageCanvas img`).map(function () {
		let key = jQuery(this).parents(".imageWrapper").attr("id").replace('wrap_', '')
		if (window.images[key]["position_v"] != 0) {
			window.saveData(key, "position_v", 0)
			window.images[key]["position_v"] = 0
		}

		if (window.images[key]["position_h"] != 0) {
			window.saveData(key, "position_h", 0)
			window.images[key]["position_h"] = 0
		}
	})
}

class Card extends React.Component {
  img = ""
  id = 0

  buff_offsetX = 0
  buff_offsetY = 0

  buff_X = 0
  buff_Y = 0

  constructor(props) {
    super(props);

    this.id = this.props.id


    if (this.props.preload) {
      this.state = { "preload": true }
    }
    else {
      this.state = window.filterImagesByPaperSize_list[this.props.id];
    }


    this.handleRotateClick = this.handleRotateClick.bind(this);
    this.handleCadrClick = this.handleCadrClick.bind(this);
    this.handleTypeClick = this.handleTypeClick.bind(this);
    this.handleLamClick = this.handleLamClick.bind(this);
    this.handleChangeCount = this.handleChangeCount.bind(this);


    this.handlePreloadClick = this.handlePreloadClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  handleRotateClick() {
    // console.log(this.state.position_rotate)
    if (this.state.position_rotate === 'h') {

      window.saveDataList(this.id, {
        "position_rotate": "v",
        "position_v": 0,
        "position_h": 0,
      })

      window.images[this.id]["position_h"] = 0
      window.images[this.id]["position_v"] = 0
      this.setState({ position_h: 0, position_v: 0, position_rotate: 'v' });
    } else {
      window.saveDataList(this.id, {
        "position_rotate": "h",
        "position_v": 0,
        "position_h": 0,
      })

      window.images[this.id]["position_h"] = 0
      window.images[this.id]["position_v"] = 0
      this.setState({ position_h: 0, position_v: 0, position_rotate: 'h' });
    }
  }

  handleTypeClick() {
    // console.log(this.state.paper_type)
    let c_type = nextType(this.state.paper_type)
    this.setState({ paper_type: c_type });
    window.saveData(this.id, 'paper_type', c_type);
  }

  handleCadrClick() {
    if (this.state.cadr == 0) {
      this.setState({ cadr: 1 });
      window.saveData(this.id, 'cadr', 1);
    }
    else if (this.state.cadr == 1) {
      this.setState({ cadr: 0 });
      window.saveData(this.id, 'cadr', 0);
    }
  }

  handlePreloadClick() {
    let preload_card = window.preload_list_card[this.id]
    if (preload_card && preload_card.image_id != null) {
      // console.log("Клик - прелойдер", "Удача")
      // delete window.preload_list_card[this.id]
      delete window.images[this.id]
      this.id = preload_card.image_id
      let image = window.images[preload_card.image_id]
      image['preload'] = false
      this.state = window.images[preload_card.image_id]
      // console.log("Удаление прелойдера", image, this)
      this.setState(image);
    }
  }

  handleLamClick() {
    // console.log(this.state.laminat)
    if (this.state.laminat == 0) {
      if (window.saveData(this.id, 'laminat', 1)) {
        this.setState({ laminat: 1 });
      }
    }
    else if (this.state.laminat == 1) {
      if (window.saveData(this.id, 'laminat', 0)) {
        this.setState({ laminat: 0 });
      }
    }
  }

  handleChangeCount(event) {
    // console.log(this.state.count)
    this.setState({ count: event.target.value });
    window.saveData(this.id, 'count', event.target.value);
  }

  render() {
    if (this.state?.preload) {
      // console.log("Отрисовался прелойдер", this.state, this.id, this)
      return (
        <div class="imageWrapper preload" onClick={this.handlePreloadClick} id={this.id}>
          <div class="ring"></div>
        </div>
      )
    }








    // Кнопка кодрирования
    let cadr_title = ""
    let cadr_class = ""
    if (this.state.cadr == 1) {
      cadr_title = 'Кадрировать'
      cadr_class = "fa-solid fa-crop-simple"
    }
    if (this.state.cadr == 0) {
      cadr_title = 'Отменить кадрирование'
      cadr_class = "fa-solid fa-crop"
    }

    // Кнопка тип бумаги
    let paper_type_title = ""
    let paper_type_abbr = ""

    paper_type_title = window.types[this.state.paper_type]["title"]
    paper_type_abbr = window.types[this.state.paper_type]["abbr"]


    // Кнопка лиминирование
    let lam_title = ""
    let lam_class = ""
    if (this.state.laminat == 1) {
      lam_title = 'С ламинацией'
      lam_class = "controlLamButton top_control_element"
    }
    if (this.state.laminat == 0) {
      lam_title = 'Без ламинации'
      lam_class = "controlLamButton top_control_element controlNolamButton"
    }


    // input количества
    let count_val = this.state.count



    // Отрисовка изображения
    let size = window.sizes[this.state["paper_size"]];
    if ((parseInt(size['thumb_w']) < parseInt(size['thumb_h']) && this.state["position_rotate"] == 'h') || (parseInt(size['thumb_w']) >= parseInt(size['thumb_h']) && this.state["position_rotate"] == 'v')) {
      let tmp = size['thumb_w'];
      size['thumb_w'] = size['thumb_h'];
      size['thumb_h'] = tmp;
    }


    let canvas_style = {
      "width": size['thumb_w'] + 2,
      "height": size['thumb_h'] + 2,
    }

    let ih = 0;
    let iw = 0;
    if (this.state["position_rotate"] == 'h') {
      iw = canvasSize;
      ih = Math.round(iw / this.state["w"] * this.state["h"]);
      if (ih > size['thumb_h']) {
        iw = Math.round(size['thumb_h'] / ih * iw);
        ih = size['thumb_h'];
      }
    } else {
      ih = canvasSize;
      iw = Math.round(ih / this.state["h"] * this.state["w"]);
      if (iw > size['thumb_w']) {
        ih = Math.round(size['thumb_w'] / iw * ih);
        iw = size['thumb_w'];
      }
    }

    let img_style = {}

    let canvas_class = "imageCanvas"


    if (this.state["cadr"] == 2) {
      canvas_class += " original"
    }

    if (this.state["cadr"] == 2 || this.state["cadr"] == 1) {
      img_style = {
        "position": "relative",
        "width": iw + "px",
        "height": ih + "px",
        "top": "0px",
        "left": "0px",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center"
      };
    }
    else {
      img_style = {
        "position": "relative",
        "width": iw + "px",
        "height": ih + "px",
        "top": "0px",
        "left": "0px"
      }
    }

    let img_elem_html = ""
    let imageCanvasContainer_h = ""

    if (this.state.cadr == 1 || this.state.cadr == 2) {
      img_elem_html = this.renderFields(this.id, this.state);
    }
    if (this.state.cadr == 0) {
      img_elem_html = this.renderCrop(this.id, this.state);
    }

    // console.log(img_elem_html, imageCanvasContainer_h)

    let controlCrop = ""

    if (this.state.cadr !== 2) {
      controlCrop = (<a href="#" className="controlCrop" onClick={this.handleCadrClick} data-bs-toggle="tooltip" data-bs-placement="bottom" title={cadr_title}><i className={cadr_class}></i></a>)
    }

    return (<div className="imageWrapper" id={`wrap_${this.id}`} data-cadr={this.state.cadr}>
      <div className="imageControls">
        <input className="form-check-input imageSelect" type="checkbox" value={`wrap_${this.id}`}></input>
        <a href="#" className="controlRotate" onClick={this.handleRotateClick} data-bs-toggle="tooltip" data-bs-placement="bottom" title="Повернуть картинку">
          <i className="fa-solid fa-arrows-rotate"></i>
        </a>
        {controlCrop}
        <button type="button" className="controlTypeButton top_control_element" onClick={this.handleTypeClick} title={paper_type_title}>{paper_type_abbr}</button>
        <button type="button" className={lam_class} title={lam_title} onClick={this.handleLamClick}>Л</button>
        <a href="#" data-bs-toggle="tooltip" data-bs-placement="bottom" style={{ "margin-right": "5px" }}>
          <i className="fa-solid fa-magnifying-glass"></i>
        </a>
      </div>
      <div className="imageCanvasContainer" id={`wrInner_${this.id}`} data-h={imageCanvasContainer_h} style={{ "height": `calc(${canvas_style['height']}px * var(--card-scale))` }}>
        <div className={canvas_class} style={canvas_style}>
          {img_elem_html}
        </div>
      </div>
      <div className="input-group input-group-sm countsControl">
        <button className="btn btn-light" type="button">-</button>
        <input type="number" className="form-control" value={count_val} onChange={this.handleChangeCount}></input>
        <button className="btn btn-light" type="button">+</button></div>
    </div>
    )
  }

  renderFields(key, val) {
    let size = window.sizes[val.paper_size];

    let ih = 0;
    let iw = 0;
    if (val.position_rotate == 'h') {
      iw = canvasSize;
      ih = Math.round(iw / val.w * val.h);
      if (ih > size['thumb_h']) {
        iw = Math.round(size['thumb_h'] / ih * iw);
        ih = size['thumb_h'];
      }
    } else {
      ih = canvasSize;
      iw = Math.round(ih / val.h * val.w);
      if (iw > size['thumb_w']) {
        ih = Math.round(size['thumb_w'] / iw * ih);
        iw = size['thumb_w'];
      }
    }

    let img = "/upload/thumb/" + getImagePathForBrowser(this.state.fname)

    let image = <img loading="lazy" src={img} style={{ "width": iw, "height": ih }}></img>

    return image;
  }

  renderCrop(key, val) {
    let size = window.sizes[this.state["paper_size"]];

    let ih = 0;
    let iw = 0;

    if (this.state["position_rotate"] == 'h') {
      ih = size['thumb_h'];
      iw = Math.round(ih / this.state["h"] * this.state["w"]);
      if (iw < size['thumb_w']) {
        ih = Math.round(size['thumb_w'] / iw * ih);
        iw = size['thumb_w'];
      }
    } else {
      iw = size['thumb_w'];
      ih = Math.round(iw / this.state["w"] * this.state["h"]);
      if (ih < size['thumb_h']) {
        iw = Math.round(size['thumb_h'] / ih * iw);
        ih = size['thumb_h'];
      }
    }

    let p_v = this.state["position_v"];
    let p_h = this.state["position_h"];

    let maxPosW = Math.floor(size['thumb_w'] - iw) + 1;
    let maxPosH = Math.floor(size['thumb_h'] - ih) + 1;

    // p_v = -Math.min(Math.abs(p_v), maxPosW);
    // p_h = -Math.min(Math.abs(p_h), maxPosH);


    let img = "/upload/thumb/" + getImagePathForBrowser(this.state.fname)

    let image = <img
      loading="lazy"
      src={img}
      style={{ "width": iw, "height": ih, "position": "relative", "top": p_v, "left": p_h, "cursor": "grabbing" }}>
    </img>
    return image;
  }
}

window.filterImagesByPaperSize_list = [];
window.select_tab = 0;

function filterImagesByPaperSize() {
  let filteredImages = {};

  if (!window?.select_tab)
    window.select_tab = 0

  for (let key in window.images) {
    if (window.images[key]['paper_size'] == window.select_tab) {
      filteredImages[key] = window.images[key];
    }
  }

  // console.log("Применена фильтрация по типам", window.select_tab, window.sizes[window.select_tab]["title"], Object.keys(filteredImages).length, filteredImages)

  window.filterImagesByPaperSize_list = filteredImages;
}


class CardEmpty extends React.Component {
  render() {
    return (<div className="empty_card"></div>)
  }
}

class App extends React.Component {
  render() {
    reset_imageCanvas_position()
    filterImagesByPaperSize()
    this.id = this.props.id
    let empty_reset = this.props.empty_reset

    if (empty_reset == "true") {
      window.reset_element(false)
      return (
        <VirtuosoGrid
          totalCount={0}
          overscan={500}
          components={{
            List: ListContainer,
            ScrollSeekPlaceholder: ({ height, width, index }) => (
              <CardEmpty />
            ),
          }}
          itemContent={index =>
            <CardEmpty />
          }
        />
      )
    }

    let list_keys = Object.keys(window.filterImagesByPaperSize_list)
    let card_size_conf = window.card_size > 1 ? window.card_size : 1
    return (
      <VirtuosoGrid
        style={{ height: "100%" }}
        totalCount={Object.keys(window.filterImagesByPaperSize_list).length}
        overscan={1000 * card_size_conf}
        components={{
          List: ListContainer,
          ScrollSeekPlaceholder: ({ height, width, index }) => (
            <CardEmpty />
          ),
        }}
        itemContent={index =>
          <Card id={list_keys[index]} />
        }
        scrollSeekConfiguration={{
          enter: velocity => Math.abs(velocity) > 800,
          exit: velocity => Math.abs(velocity) < 30,
          // change: (prevRange, newRange) => {

          // console.log("change", prevRange, newRange)

          //   return {
          //     ...newRange,
          //     paddingTop: paddingTop,
          //     paddingBottom: paddingBottom
          //   }

          // }
        }}
      />
    )
  }
}

export default App